export default __webpack_public_path__ + "static/media/08_photo.0257b746.jpg";